import React from 'react';

import { usePermissionsContext } from 'context/PermissionsContext';
import { DetalhamentoCreditosImportacaoComp } from 'pages/financeiro/detalhamento-creditos/importar/components';

export function DetalhamentoCreditosImportacao() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();
    if (!hasPermission(['FINANCEIRO_DETALHAMENTO_CREDITO_VISUALIZAR'])) return alertNotPermission();

    return <DetalhamentoCreditosImportacaoComp />;
}
